import { PublicKey } from "@solana/web3.js";
export const HAPI_PROGRAM_ID = new PublicKey("hapiScWyxeZy36fqXD5CcRUYFCUdid26jXaakAtcdZ7");
//# sourceMappingURL=constants.js.map